export const buildExportCheckedKeys = <TExportKey extends string>(
  exportKeys: readonly TExportKey[],
  tableKeyByExportKey: Partial<Record<TExportKey, string>>,
  visibleTableKeys: string[],
): Set<TExportKey> =>
  new Set(
    exportKeys.filter(exportKey => {
      const tableKey = tableKeyByExportKey[exportKey];
      if (!tableKey) return true;

      return visibleTableKeys.includes(tableKey);
    }),
  );
